const getNavigationElements = () => {
    const navToggle = document.getElementById('nav-toggle');
    const navigation = document.getElementById('main-navigation');
    const overlay = document.getElementById('nav-overlay');
    return {
        navToggle,
        navigation,
        overlay,
    };
};
const manageFocusOrder = () => {
    const navToggle = document.getElementById('nav-toggle');
    const skipNav = document.querySelector('.spv-campaignPage__skip-nav');
    const allFocusableElements = Array.from(document.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    if (navToggle) {
        navToggle.setAttribute('tabindex', '1');
    }
    allFocusableElements.forEach(element => {
        if (element !== navToggle && element !== skipNav && element.getAttribute('tabindex') !== '-1') {
            element.removeAttribute('tabindex');
        }
    });
};
const createSkipNavigation = () => {
    const skipNav = document.querySelector('.spv-campaignPage__skip-nav');
    skipNav?.addEventListener('click', event => {
        event.preventDefault();
        const navToggle = document.getElementById('nav-toggle');
        if (navToggle) {
            navToggle.focus();
        }
    });
};
const updateAriaExpanded = (isExpanded) => {
    const navToggle = document.getElementById('nav-toggle');
    if (navToggle) {
        navToggle.setAttribute('aria-expanded', isExpanded.toString());
    }
};
const setNavigationFocusability = (focusable) => {
    const navigation = document.getElementById('main-navigation');
    if (!navigation)
        return;
    const mainItems = navigation.querySelectorAll('.spv-campaignPage__navigationListItem');
    mainItems.forEach(element => {
        if (element.querySelector(':scope > a'))
            return;
        if (focusable) {
            element.setAttribute('tabindex', '0');
        }
        else {
            element.setAttribute('tabindex', '-1');
        }
    });
    const allSublistItems = navigation.querySelectorAll('.spv-campaignPage__navigationSublist a');
    allSublistItems.forEach(element => {
        const listItem = element.closest('.spv-campaignPage__navigationListItem');
        const isParentExpanded = listItem?.classList.contains('spv-campaignPage__navigationListItem--active');
        if (focusable && isParentExpanded) {
            element.setAttribute('tabindex', '0');
        }
        else {
            element.setAttribute('tabindex', '-1');
        }
    });
};
const handleSublistKeyboard = (event, sublist) => {
    const focusableItems = Array.from(sublist.querySelectorAll('a[tabindex="0"]'));
    const currentIndex = focusableItems.indexOf(event.target);
    switch (event.key) {
        case 'ArrowDown':
            event.preventDefault();
            const nextIndex = (currentIndex + 1) % focusableItems.length;
            focusableItems[nextIndex].focus();
            break;
        case 'ArrowUp':
            event.preventDefault();
            const prevIndex = currentIndex === 0 ? focusableItems.length - 1 : currentIndex - 1;
            focusableItems[prevIndex].focus();
            break;
        case 'Home':
            event.preventDefault();
            focusableItems[0].focus();
            break;
        case 'End':
            event.preventDefault();
            focusableItems[focusableItems.length - 1].focus();
            break;
    }
};
export const navigationHandlers = {
    openNavigation: () => {
        const { navigation, navToggle, overlay } = getNavigationElements();
        document.body.setAttribute('data-lenis-prevent', '');
        navigation.classList.add('spv-campaignPage__navigation--active');
        overlay.classList.add('spv-campaignPage__overlay--active');
        navToggle.classList.add('spv-campaignPage__navActive');
        navToggle.setAttribute('aria-expanded', 'true');
        setNavigationFocusability(true);
        const firstItem = navigation.querySelector('.spv-campaignPage__navigationListItem[tabindex="0"]');
        if (firstItem) {
            firstItem.focus();
        }
    },
    closeNavigation: () => {
        const { navigation, navToggle, overlay } = getNavigationElements();
        navigation.classList.remove('spv-campaignPage__navigation--active');
        overlay.classList.remove('spv-campaignPage__overlay--active');
        navToggle.classList.remove('spv-campaignPage__navActive');
        navToggle.setAttribute('aria-expanded', 'false');
        document.body.removeAttribute('data-lenis-prevent');
        setNavigationFocusability(false);
        navToggle.focus();
    },
    toggleNavigation: () => {
        const { navigation } = getNavigationElements();
        const isOpen = navigation.classList.contains('spv-campaignPage__navigation--active');
        if (isOpen) {
            navigationHandlers.closeNavigation();
        }
        else {
            navigationHandlers.openNavigation();
        }
    },
};
export const navigationScripts = () => {
    return document.addEventListener('DOMContentLoaded', function () {
        const navToggle = document.getElementById('nav-toggle');
        const navigation = document.getElementById('main-navigation');
        const overlay = document.getElementById('nav-overlay');
        const navItems = document.querySelectorAll('.spv-campaignPage__navigationListItem');
        createSkipNavigation();
        manageFocusOrder();
        navToggle.setAttribute('aria-controls', 'main-navigation');
        navToggle.setAttribute('aria-expanded', 'false');
        setNavigationFocusability(false);
        navToggle.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                navigationHandlers.toggleNavigation();
            }
        });
        navToggle.addEventListener('click', function () {
            navigationHandlers.toggleNavigation();
        });
        overlay.addEventListener('click', function () {
            navigationHandlers.closeNavigation();
        });
        document.addEventListener('keydown', function (e) {
            if ((e.ctrlKey || e.altKey) && e.key === 'm') {
                e.preventDefault();
                navToggle.focus();
            }
        });
        navigation.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                navigationHandlers.closeNavigation();
                return;
            }
            const items = Array.from(navigation.querySelectorAll('.spv-campaignPage__navigationListItem[tabindex="0"]'));
            const currentItem = event.target;
            if (currentItem.classList.contains('spv-campaignPage__navigationListItem')) {
                const currentIndex = items.indexOf(currentItem);
                switch (event.key) {
                    case 'ArrowDown':
                        event.preventDefault();
                        const nextIndex = (currentIndex + 1) % items.length;
                        items[nextIndex].focus();
                        break;
                    case 'ArrowUp':
                        event.preventDefault();
                        const prevIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
                        items[prevIndex].focus();
                        break;
                    case 'Home':
                        event.preventDefault();
                        items[0].focus();
                        break;
                    case 'End':
                        event.preventDefault();
                        items[items.length - 1].focus();
                        break;
                    case 'ArrowRight':
                        if (currentItem.classList.contains('spv-campaignPage__navigationListItem--active')) {
                            event.preventDefault();
                            const firstSubItem = currentItem.querySelector('.spv-campaignPage__navigationSublist a[tabindex="0"]');
                            if (firstSubItem) {
                                firstSubItem.focus();
                            }
                        }
                        break;
                }
            }
            if (event.target.closest('.spv-campaignPage__navigationSublist')) {
                const sublist = event.target.closest('.spv-campaignPage__navigationSublist');
                if (sublist) {
                    if (event.key === 'ArrowLeft') {
                        event.preventDefault();
                        const parentItem = sublist
                            .closest('.spv-campaignPage__navigationListItem');
                        if (parentItem) {
                            parentItem.focus();
                        }
                    }
                    else {
                        handleSublistKeyboard(event, sublist);
                    }
                }
            }
        });
        navItems.forEach((item, index) => {
            if (item.querySelector(':scope > a'))
                return;
            const sublist = item.querySelector('.spv-campaignPage__navigationSublist');
            const itemId = `nav-item-${index}`;
            const sublistId = `nav-sublist-${index}`;
            item.id = itemId;
            if (sublist) {
                item.setAttribute('aria-expanded', 'false');
                item.setAttribute('aria-controls', sublistId);
                sublist.id = sublistId;
                sublist.setAttribute('aria-labelledby', itemId);
            }
            item.setAttribute('tabindex', '-1');
            item.addEventListener('click', function (e) {
                if (e.target.closest('.spv-campaignPage__navigationSublist'))
                    return;
                navItems.forEach(otherItem => {
                    if (otherItem !== item &&
                        otherItem.classList.contains('spv-campaignPage__navigationListItem--active')) {
                        otherItem.classList.remove('spv-campaignPage__navigationListItem--active');
                        otherItem.setAttribute('aria-expanded', 'false');
                        const otherSublist = otherItem.querySelector('.spv-campaignPage__navigationSublist');
                        if (otherSublist) {
                            otherSublist.querySelectorAll('a').forEach(link => {
                                link.setAttribute('tabindex', '-1');
                            });
                        }
                    }
                });
                const isExpanded = item.classList.contains('spv-campaignPage__navigationListItem--active');
                if (isExpanded) {
                    item.classList.remove('spv-campaignPage__navigationListItem--active');
                    item.setAttribute('aria-expanded', 'false');
                    if (sublist) {
                        sublist.querySelectorAll('a').forEach(link => {
                            link.setAttribute('tabindex', '-1');
                        });
                    }
                }
                else {
                    item.classList.add('spv-campaignPage__navigationListItem--active');
                    item.setAttribute('aria-expanded', 'true');
                    if (sublist) {
                        sublist.querySelectorAll('a').forEach(link => {
                            link.setAttribute('tabindex', '0');
                        });
                    }
                }
            });
            item.addEventListener('keydown', function (event) {
                const keyboardEvent = event;
                if (keyboardEvent.key === ' ' || keyboardEvent.key === 'Enter') {
                    keyboardEvent.preventDefault();
                    item.click();
                }
            });
        });
    });
};
//# sourceMappingURL=navigation.js.map